import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Alpha } from "Pages/Alpha";
import { Home } from "Pages/Home";
import { Insights } from "Pages/Insights";
import { Layout } from "Pages/Layout";
import { About } from "Pages/About";

export const WebRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="insights" element={<Insights />} />
          <Route path="alpha" element={<Alpha />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
